<template>
  <div class="preview">
    <div class="preview-label">
      <h1 class="message-preview-text">Message Preview</h1>
    </div>
    <div class="ui">
      <div class="preview-header">
        <label class="code">+852 622649290158</label>
      </div>
      <div class="preview-content">
        <div class="message-container-wrapper">
          <!-- <div class="message-container" v-for="(item, index) in items" v-bind:key="index"> -->
          <div class="message-container" v-show="this.msg">
            <div class="message">
              <div class="message-content">
                <span>{{this.msg}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import replacePlaceHolder from '../utils/replacePlaceHolder'
export default {
  name: "preview",
  // data() {
  //   return {
  //     breakPoint: [160, 306, 459],
  //   }
  // },
  props: {
    msg: String,
    breakPoint: Array
  },
  computed: {
    items() {
      var arr = []
      var message = this.msg
      for (var messageNums = 0; messageNums < this.breakPoint.length; messageNums++) {
        var previewText = message.slice(this.breakPoint[messageNums - 1] || 0, this.breakPoint[messageNums])
        if (previewText) {
          arr.push(previewText)
        }
      }
      return arr
    }
  },
};
</script>

<style lang="css">
.preview {
  position: relative;
  display: inline-block;
  padding: 15px;
  height: 433.5px;
  background: #f4f6f9;
  border-radius: 4px;
  border: 1px solid #d8dde6;
  margin-left: 10px;
}

.preview .preview-label {
  display: inline-block;
  /* margin-bottom: 15px; */
}

.preview .preview-label h1 {
  font-size: 14px;
  line-height: 1;
  font-weight: 400;
  margin: 0 0 10px;
}

.preview .ui {
  width: 275px;
  height: 372px;
  position: relative;
  margin: 0 auto;
  background: white;
  border: 1px solid #d8dde6;
  overflow: hidden;
}

.preview .ui .preview-header {
  width: 100%;
  height: 63px;
  background: url(../assets/iPhone-header.svg) no-repeat 0 0;
  background-size: 100%;
  text-align: center;
}

.preview .ui .preview-header label {
  display: inline-block;
  margin-top: 47px;
  font-size: 10px;
  margin-left: 1px;
}

.preview .preview-content {
  padding-top: 20px;
  overflow-y: auto;
  overflow-x: hidden;
  /* height: 225px; */
  height: 309px;
}

.preview .ui .message-container {
  display: block;
  position: relative;
  margin-bottom: 10px;
}

.preview .message-container .message {
  font-family: "Helvetica Neue", "Helvetica";
  display: block;
  background: #e5e5ea;
  font-size: 11px;
  width: auto;
  position: relative;
  margin-left: 15px;
  border-radius: 15px;
  padding: 10px;
  color: black !important;
  display: inline-block;
  max-width: 186px;
  word-wrap: break-word;
  padding-left: 13px;
  padding-right: 13px;
  margin-bottom: 2px;
}

.preview .message-container:before {
  content: "";
  position: absolute;
  z-index: 2;
  bottom: 1px;
  left: 7px;
  height: 14px;
  border-left: 20px solid #e5e5ea;
  border-bottom-right-radius: 16px 14px;
  -webkit-transform: translate(0, -2px);
}

.preview .message-container:after {
  content: "";
  position: absolute;
  z-index: 3;
  bottom: 0px;
  left: 35px;
  width: 10px;
  height: 20px;
  background: white;
  border-bottom-right-radius: 10px;
  -webkit-transform: translate(-30px, -2px);
}
</style>
